module.exports = __webpack_public_path__ + "img/358707.08c57432.svg";